import React from "react";
import MainPageLayout from "./layout";

export default function MainPage() {
  return <MainPageLayout />;
}
